// POS Defaults shim for platform-app's services/posApiService.
//
// The copied editors edit the GLOBAL RubyTill default, not one business, so
// every tenant-scoped call they make has no meaning here:
//   - taxesFeesApi: taxes/fees are per business → empty lists (the Custom Item
//     tab shows a note instead of the picker).
//   - uploadsApi: the default never carries a store logo or picture → uploads
//     are hidden in the UI; this throws if anything still reaches it.
export const taxesFeesApi = {
  list: async (_params?: { type?: 'tax' | 'fee' }): Promise<{ taxesFees: any[] }> => ({ taxesFees: [] }),
};

export const uploadsApi = {
  sign: async (_body: { fileName: string; contentType: string; folder?: string; [k: string]: unknown }): Promise<{ uploadUrl: string; fileUrl: string }> => {
    throw new Error('Uploads are not available on the RubyTill default — each business adds its own images.');
  },
};
